import React from 'react';
import { ErrorHandlingMedia } from '../../common/ErrorHandlingMedia';

interface MediaDisplayProps {
  mediaUrl?: string;
  altText: string;
  type: 'image' | 'video';
  format?: string;
  variant?: string;
  objectFit?: 'cover' | 'contain';
  aspectRatio?: string;
  className?: string;
}

export const MediaDisplay: React.FC<MediaDisplayProps> = ({
  mediaUrl,
  altText,
  type,
  objectFit = 'cover',
  aspectRatio,
  className = ''
}) => {
  if (!mediaUrl) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 w-full h-full ${className}`}>
        <span className="text-gray-400 text-xs">No media</span>
      </div>
    );
  }

  const style = {
    objectFit,
    aspectRatio
  };

  return (
    <ErrorHandlingMedia
      src={mediaUrl}
      alt={altText}
      type={type}
      className={`w-full h-full ${className}`}
      style={style}
      controls={type === 'video'}
    />
  );
};